import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

export default function QuestionIcon() {
    return (
        <Svg width={47} height={48} viewBox="0 0 47 48" fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47 24C47 10.746 36.478 0 23.5 0S0 10.746 0 24s10.522 24 23.5 24S47 37.254 47 24zm-20.689 5.133h-6.69v-.684c0-1.16.123-2.105.383-2.832.26-.73.643-1.387 1.151-1.992.513-.602 1.664-1.652 3.447-3.168.948-.793 1.426-1.516 1.426-2.172 0-.668-.195-1.176-.573-1.543-.383-.363-.96-.547-1.737-.547-.838 0-1.522.285-2.065.844-.547.563-.895 1.55-1.048 2.953l-6.84-.867c.234-2.566 1.148-4.633 2.735-6.191 1.596-1.57 4.036-2.348 7.321-2.348 2.563 0 4.628.547 6.2 1.637 2.142 1.476 3.206 3.445 3.206 5.898 0 1.024-.28 2.008-.826 2.953-.551.953-1.68 2.106-3.386 3.469-1.181.969-1.931 1.734-2.24 2.316-.31.578-.464 1.34-.464 2.274zm-6.927 1.824h7.176v6.457h-7.176v-6.457z"
                fill="#fff"
            />
        </Svg>
    );
}
